export const API_BASE = "https://api.morizonsadmin.com/api/v1";
export const SOCKET_API_BASE = "https://api.morizonsadmin.com/";
